import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let EqualizerIcon = (props) => {
  props = Object.assign({viewBox: '0 0 70 70'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <g>
          <path d="M28.3,42.7"/>
          <path d="M28.3,42.7"/>
          <path d="M28.3,37.9"/>
          <path d="M28.3,37.9"/>
          <path d="M28.3,41c-2.6,0-4.8-2.1-4.8-4.8c0-2.6,2.2-4.8,4.8-4.8s4.8,2.2,4.8,4.8C33.1,38.9,31,41,28.3,41z M28.3,34.3
			c-1.1,0-1.9,0.9-1.9,1.9c0,1.1,0.9,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9C30.2,35.2,29.4,34.3,28.3,34.3z"/>
          <rect x="26.9" y="8.5" width="2.9" height="24.4"/>
          <rect x="26.9" y="39.6" width="2.9" height="21.9"/>
        </g>
        <g>
          <path d="M41.7,39.8"/>
          <path d="M41.7,39.8"/>
          <path d="M41.7,35.1"/>
          <path d="M41.7,35.1"/>
          <path d="M41.7,38.2c-2.6,0-4.8-2.2-4.8-4.8s2.1-4.8,4.8-4.8c2.6,0,4.8,2.2,4.8,4.8S44.3,38.2,41.7,38.2z M41.7,31.5
			c-1.1,0-1.9,0.9-1.9,1.9s0.9,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9S42.8,31.5,41.7,31.5z"/>
          <rect x="40.3" y="8.5" width="2.9" height="21.5"/>
          <rect x="40.3" y="36.8" width="2.9" height="24.7"/>
        </g>
        <g>
          <path d="M55.1,29.8"/>
          <path d="M55.1,29.8"/>
          <path d="M55.1,26.5"/>
          <path d="M55.1,26.5"/>
          <path d="M55.1,29.6c-2.6,0-4.8-2.2-4.8-4.8s2.1-4.8,4.8-4.8c2.6,0,4.8,2.2,4.8,4.8S57.7,29.6,55.1,29.6z M55.1,22.9
			c-1.1,0-1.9,0.9-1.9,1.9c0,1.1,0.9,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9S56.1,22.9,55.1,22.9z"/>
          <rect x="53.6" y="8.5" width="2.9" height="13"/>
          <rect x="53.6" y="28.2" width="2.9" height="33.3"/>
        </g>
        <g>
          <path d="M14.9,31.2"/>
          <path d="M14.9,31.2"/>
          <path d="M14.9,26.5"/>
          <path d="M14.9,26.5"/>
          <path d="M14.9,29.6c-2.6,0-4.8-2.2-4.8-4.8s2.2-4.8,4.8-4.8s4.8,2.2,4.8,4.8S17.6,29.6,14.9,29.6z M14.9,22.9
			c-1.1,0-1.9,0.9-1.9,1.9c0,1.1,0.9,1.9,1.9,1.9s1.9-0.9,1.9-1.9C16.9,23.8,16,22.9,14.9,22.9z"/>
          <rect x="13.5" y="8.5" width="2.9" height="13"/>
          <rect x="13.5" y="28.2" width="2.9" height="33.3"/>
        </g>
      </g>
    </SvgIcon>
  );
};

EqualizerIcon.displayName = 'EqualizerIcon';
EqualizerIcon.muiName = 'SvgIcon';

export default EqualizerIcon;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/HeaderOne/icons/Equalizer.Icon.js